function HomeIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={`M19.6585 9.37438L12.6585 3.24938C12.2815 2.91948 11.7185 2.91948 11.3415 3.24938L4.3415 9.37438C4.12448 
      9.56426 4 9.83859 4 10.127V18.9994C4 19.5517 4.44772 19.9994 5 19.9994H9C9.55228 19.9994 10 19.5517 10 
      18.9994V14.9994C10 14.4471 10.4477 13.9994 11 13.9994H13C13.5523 13.9994 14 14.4471 14 14.9994V18.9994C14 
      19.5517 14.4477 19.9994 15 19.9994H19C19.5523 19.9994 20 19.5517 20 18.9994V10.127C20 9.83859 19.8755 
      9.56427 19.6585 9.37438Z`}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HomeIcon;
